import { useQuery } from "@tanstack/react-query";

import { CLIENT_LIST_USER_TOKENS } from "./query-keys";
import useAccountsApi from "./use-accounts-api";

export default function useClientListUserTokens(props?: { refetch?: number }) {
  const api = useAccountsApi();

  const fetchMethod = async () => {
    const result = await api.clientListUserTokens();
    return result;
  };

  return useQuery({
    queryKey: [CLIENT_LIST_USER_TOKENS],
    queryFn: fetchMethod,
    refetchInterval: props?.refetch,
    initialData: [],
  });
}
